export default __webpack_public_path__ + "static/media/heroPicture.da7563bc.jpg";